import React, { useState, useEffect } from 'react';
import s from './TeacherThemes.module.css';
import ss from './TeacherStudents.module.css';

export const TeacherStudents = () => {
  const token = localStorage.getItem('token');

  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [students, setStudents] = useState([]); // итоговые данные
  const [loading, setLoading] = useState(false);
  const [loadingGroups, setLoadingGroups] = useState(true);

  // Для редактирования оценки
  const [editingAnswer, setEditingAnswer] = useState(null); // { id, ball, komment, javob, studentName, savol }
  const [editBall, setEditBall] = useState('');
  const [editKomment, setEditKomment] = useState('');
  const [editActive, setEditActive] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState('');

  // Раскрытый студент
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const res = await fetch('https://api.aiassessment.uz/api/gruh/', {
          headers: { Authorization: `Token ${token}` },
        });
        const data = await res.json();
        setGroups(Array.isArray(data) ? data : []);
      } finally {
        setLoadingGroups(false);
      }
    };
    fetchGroups();
  }, []);

  useEffect(() => {
    if (!selectedGroup) return;
    loadStudents(selectedGroup);
  }, [selectedGroup]);

  const loadStudents = async (gruhId) => {
    setLoading(true);
    setStudents([]);
    setExpandedId(null);

    try {
      const [customRes, usersRes, answersRes] = await Promise.all([
        fetch('https://api.aiassessment.uz/api/custom-users/', {
          headers: { Authorization: `Token ${token}` },
        }),
        fetch('https://api.aiassessment.uz/api/users/', {
          headers: { Authorization: `Token ${token}` },
        }),
        fetch('https://api.aiassessment.uz/api/yozma-javob/', {
          headers: { Authorization: `Token ${token}` },
        }),
      ]);

      const allCustomUsers = await customRes.json();
      const allUsers = await usersRes.json();
      const allAnswers = await answersRes.json();

      // Фильтруем custom-users по группе на клиенте
      const customUsers = allCustomUsers.filter(cu => cu.gruh === Number(gruhId));

      const group = groups.find(g => g.id === Number(gruhId));
      const oraliq = group?.oraliq ?? 0;

      const result = customUsers.map(cu => {
        const userInfo = allUsers.find(u => u.id === cu.user) ?? {};
        // Ответы фильтруем по user и gruh на клиенте
        const answers = allAnswers.filter(a => a.user === cu.user && a.gruh === Number(gruhId) && a.active === true);
        const allAnswersForStudent = allAnswers.filter(a => a.user === cu.user && a.gruh === Number(gruhId));

        let avgPercent = null;
        let finalBall = null;

        if (answers.length > 0) {
          const sum = answers.reduce((acc, a) => acc + (a.ball ?? 0), 0);
          avgPercent = Math.round(sum / answers.length);
          finalBall = Math.ceil(oraliq * avgPercent / 100);
        }

        return {
          customUserId: cu.id,
          userId: cu.user,
          username: userInfo.username ?? '—',
          first_name: userInfo.first_name ?? '',
          last_name: userInfo.last_name ?? '',
          email: userInfo.email ?? '—',
          avgPercent,
          finalBall,
          oraliq,
          answers: allAnswersForStudent,
        };
      });

      setStudents(result);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const openEdit = (answer, studentName) => {
    setEditingAnswer({ ...answer, studentName });
    setEditBall(answer.ball ?? '');
    setEditKomment(answer.komment ?? '');
    setEditActive(answer.active ?? true);
    setSaveMsg('');
  };

  const handleSave = async () => {
    if (!editingAnswer) return;
    setSaving(true);
    setSaveMsg('');
    try {
      const res = await fetch(`https://api.aiassessment.uz/api/yozma-javob/${editingAnswer.id}/`, {
        method: 'PATCH',
        headers: {
          Authorization: `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ball: Number(editBall),
          komment: editKomment,
          active: editActive,
        }),
      });
      if (res.ok) {
        setSaveMsg('Saqlandi!');
        await loadStudents(selectedGroup);
        setTimeout(() => {
          setEditingAnswer(null);
          setSaveMsg('');
        }, 900);
      } else {
        setSaveMsg('Xatolik yuz berdi');
      }
    } finally {
      setSaving(false);
    }
  };

  const [resittingId, setResittingId] = useState(null);

  const handleResit = async (st) => {
    if (!window.confirm(`${fullName(st)} uchun qayta topshirish ochilsinmi?`)) return;
    setResittingId(st.userId);
    try {
      await Promise.all(
        st.answers.map(ans =>
          fetch(`https://api.aiassessment.uz/api/yozma-javob/${ans.id}/`, {
            method: 'PATCH',
            headers: { Authorization: `Token ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify({ active: false }),
          })
        )
      );
      await loadStudents(selectedGroup);
    } finally {
      setResittingId(null);
    }
  };

  const fullName = (st) =>
    [st.last_name, st.first_name].filter(Boolean).join(' ') || st.username;

  const selectedGroupData = groups.find(g => g.id === Number(selectedGroup));

  const handlePrint = () => {
    const rows = students.map((st, idx) => `
      <tr>
        <td>${idx + 1}</td>
        <td>${fullName(st)}</td>
        <td>${st.username}</td>
        <td>${st.avgPercent !== null ? st.avgPercent + '%' : '—'}</td>
        <td>${st.finalBall !== null ? st.finalBall + ' / ' + st.oraliq : '—'}</td>
      </tr>
    `).join('');

    const html = `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8" />
        <title>${selectedGroupData?.nomi ?? ''} — Baholar</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 24px; color: #111; }
          h2 { font-size: 18px; margin-bottom: 4px; }
          .meta { font-size: 13px; color: #555; margin-bottom: 20px; display: flex; gap: 24px; }
          table { width: 100%; border-collapse: collapse; font-size: 14px; }
          th { background: #3d3bff; color: #fff; padding: 10px 12px; text-align: left; font-weight: 600; }
          td { padding: 9px 12px; border-bottom: 1px solid #e0e0e0; }
          tr:last-child td { border-bottom: none; }
          tr:nth-child(even) td { background: #f7f8ff; }
          .footer { margin-top: 28px; font-size: 12px; color: #999; text-align: right; }
        </style>
      </head>
      <body>
        <h2>${selectedGroupData?.nomi ?? ''} guruhi — Talabalar baholari</h2>
        <div class="meta">
          <span>Maks. ball: <strong>${selectedGroupData?.oraliq ?? '—'}</strong></span>
          <span>Nazariy savollar: <strong>${selectedGroupData?.Nsavol ?? '—'}</strong></span>
          <span>Amaliy savollar: <strong>${selectedGroupData?.Asavol ?? '—'}</strong></span>
          <span>Talabalar soni: <strong>${students.length}</strong></span>
        </div>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>F.I.O</th>
              <th>Username</th>
              <th>O'rtacha %</th>
              <th>Ball</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
        <div class="footer">Sana: ${new Date().toLocaleDateString('uz-UZ')}</div>
      </body>
      </html>
    `;

    const win = window.open('', '_blank');
    win.document.write(html);
    win.document.close();
    win.focus();
    win.print();
  };

  return (
    <div className={ss.studentsPage}>
      <div className={s.header}>
        <h1 className={s.title}>Talabalar va baholar</h1>
        {selectedGroup && !loading && students.length > 0 && (
          <button className={ss.printBtn} onClick={handlePrint}>
            Chop etish
          </button>
        )}
      </div>

      {/* Выбор группы */}
      <div className={ss.groupSelector}>
        {loadingGroups ? (
          <p className={s.loading}>Guruhlar yuklanmoqda...</p>
        ) : (
          <div className={ss.groupTabs}>
            {groups.map(g => (
              <button
                key={g.id}
                className={`${ss.groupTab} ${String(g.id) === String(selectedGroup) ? ss.groupTabActive : ''}`}
                onClick={() => setSelectedGroup(String(g.id))}
              >
                {g.nomi}
                <span className={ss.groupMeta}>maks. ball: {g.oraliq}</span>
              </button>
            ))}
          </div>
        )}
      </div>

      {!selectedGroup && (
        <p className={ss.hint}>Guruhni tanlang</p>
      )}

      {selectedGroup && loading && (
        <p className={s.loading}>Yuklanmoqda...</p>
      )}

      {selectedGroup && !loading && (
        <>
          {selectedGroupData && (
            <div className={ss.groupInfo}>
              <span><strong>{selectedGroupData.nomi}</strong></span>
              <span>Maksimal ball: <strong>{selectedGroupData.oraliq}</strong></span>
              <span>Nazariy savollar: <strong>{selectedGroupData.Nsavol}</strong></span>
              <span>Amaliy savollar: <strong>{selectedGroupData.Asavol}</strong></span>
              <span>Vaqt: <strong>{selectedGroupData.vaqt ?? '—'} min</strong></span>
              <span className={`${ss.dostupBadge} ${selectedGroupData.dostup ? ss.dostupOpen : ss.dostupClosed}`}>
                {selectedGroupData.dostup ? 'ON ochiq' : 'ON yopiq'}
              </span>
            </div>
          )}

          <div className={ss.tableScroll}>
            <table className={s.table}>
              <thead>
                <tr>
                  <th style={{ width: 36 }}>#</th>
                  <th>F.I.O</th>
                  <th>Username</th>
                  <th>O'rtacha %</th>
                  <th>Natija</th>
                  <th>Amallar</th>
                </tr>
              </thead>
              <tbody>
                {students.length === 0 && (
                  <tr><td colSpan={6} style={{ textAlign: 'center', color: '#888' }}>Talabalar yo'q</td></tr>
                )}
                {students.map((st, idx) => (
                  <React.Fragment key={st.userId}>
                    <tr className={expandedId === st.userId ? ss.rowExpanded : ''}>
                      <td>{idx + 1}</td>
                      <td className={s.tdTitle}>
                        <div>{fullName(st)}</div>
                        <div className={ss.tdEmail}>{st.email}</div>
                      </td>
                      <td>{st.username}</td>
                      <td>
                        {st.avgPercent !== null ? (
                          <div className={ss.percentBar}>
                            <div className={ss.percentFill} style={{ width: `${st.avgPercent}%` }} />
                            <span className={ss.percentText}>{st.avgPercent}%</span>
                          </div>
                        ) : <span className={ss.noData}>—</span>}
                      </td>
                      <td>
                        {st.finalBall !== null ? (
                          <span className={`${s.badge} ${ss.ballBadge}`}>
                            {st.finalBall} / {st.oraliq}
                          </span>
                        ) : <span className={ss.noData}>—</span>}
                      </td>
                      <td>
                        <div className={ss.actionBtns}>
                          {st.answers.length > 0 ? (
                            <button
                              className={ss.expandBtn}
                              onClick={() => setExpandedId(expandedId === st.userId ? null : st.userId)}
                            >
                              {expandedId === st.userId ? '▲' : `▼ ${st.answers.length}`}
                            </button>
                          ) : <span className={ss.noData}>Javob yo'q</span>}
                          {st.answers.length > 0 && (
                            <button
                              className={ss.resitBtn}
                              onClick={() => handleResit(st)}
                              disabled={resittingId === st.userId}
                              title="Barcha javoblarni active=false ga o'zgartiradi"
                            >
                              {resittingId === st.userId ? '...' : 'Qayta topshirish'}
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>

                    {/* Раскрытые ответы */}
                    {expandedId === st.userId && st.answers.length > 0 && (
                      <tr>
                        <td colSpan={6} className={ss.answersCell}>
                          <div className={ss.answersList}>
                            {st.answers.map((ans, ai) => (
                              <div key={ans.id} className={`${ss.answerCard} ${!ans.active ? ss.answerInactive : ''}`}>
                                <div className={ss.answerHeader}>
                                  <span className={ss.answerNum}>Javob #{ai + 1}</span>
                                  {!ans.active && <span className={ss.inactiveBadge}>Hisobga olinmaydi</span>}
                                  {ans.ball !== null && (
                                    <span className={ss.ballChip}>{ans.ball} ball</span>
                                  )}
                                  <button className={ss.editBtn} onClick={() => openEdit(ans, fullName(st))}>
                                    Baholash
                                  </button>
                                </div>
                                <div
                                  className={ss.answerText}
                                  dangerouslySetInnerHTML={{ __html: ans.javob }}
                                />
                                {ans.komment && (
                                  <div className={ss.komment}>
                                    <strong>Izoh:</strong> {ans.komment}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* Модалка редактирования оценки */}
      {editingAnswer && (
        <div className={s.modalOverlay}>
          <div className={ss.editModal}>
            <h3>Baholash — {editingAnswer.studentName}</h3>

            <div className={ss.answerPreview}>
              <div dangerouslySetInnerHTML={{ __html: editingAnswer.javob }} />
            </div>

            <div className={s.field}>
              <label>Ball (0–100)</label>
              <input
                type="number"
                min={0} max={100}
                value={editBall}
                onChange={e => setEditBall(e.target.value)}
                className={s.input}
              />
            </div>

            <div className={s.field}>
              <label>Izoh (komment)</label>
              <textarea
                value={editKomment}
                onChange={e => setEditKomment(e.target.value)}
                className={s.textarea}
                rows={4}
                placeholder="O'qituvchi izohi..."
              />
            </div>

            <div className={ss.activeToggle}>
              <label className={ss.activeLabel}>
                <input
                  type="checkbox"
                  checked={editActive}
                  onChange={e => setEditActive(e.target.checked)}
                />
                <span>Hisobga olish (active)</span>
              </label>
            </div>

            {saveMsg && <p className={saveMsg === 'Saqlandi!' ? s.successMsg : s.error}>{saveMsg}</p>}

            <div className={s.formActions}>
              <button className={s.btnPrimary} onClick={handleSave} disabled={saving}>
                {saving ? 'Saqlanmoqda...' : 'Saqlash'}
              </button>
              <button className={s.btnSecondary} onClick={() => setEditingAnswer(null)}>
                Bekor
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

